/** The values the backend can answer with, so a dev stand can be pinned to any of its rails. */
const OVERRIDABLE = ['chargebee', 'round', 'round_hyperswitch'] as const;

type OverridableProvider = typeof OVERRIDABLE[number];

export function usePaymentProviderOverride(): OverridableProvider | undefined {
  const { ENVIRONMENT } = useRuntimeConfig().public;

  if (ENVIRONMENT === 'production') return undefined;

  const provider = useRouter().currentRoute.value.query.provider;

  return OVERRIDABLE.includes(provider as OverridableProvider)
    ? provider as OverridableProvider
    : undefined;
}
